import { useLocation } from "react-router";

export const selectedIdForPath = (pathname: string) => {
  if (pathname.startsWith("/email-preferences-auth"))
    return "navigation-email-preferences-auth";
  if (pathname.startsWith("/organizations")) return "navigation-organizations";
  if (pathname.startsWith("/maker-licenses"))
    return "navigation-maker-licenses";
  if (pathname.startsWith("/training")) return "navigation-training";
  if (pathname.startsWith("/profile") || pathname === "/")
    return "navigation-profile";
};

export const useIdForCurrentLocation = () => {
  const location = useLocation();

  return selectedIdForPath(location.pathname);
};
